// extracted by mini-css-extract-plugin
export default {"matchEventLinks":"PlayerProfileTabs_matchEventLinks__SsAHe"};